import {
  SourcingInternalChooseAnalysisStep,
  SourcingInternalChooseChannelStep,
  SourcingInternalSelectedCandidatesStep,
  SourcingInternalJobInformationStep,
  SourcingInternalSetupApplicationStep,
  SourcingInternalCustomizeMessageStep,
  SourcingInternalReviewInvitationsStep,
  SourcingInternalSuccessStep
} from 'modules/sourcing-internal/steps';
import { SHARED_SOURCING_STEPS } from 'modules/sourcing-shared/shared-stores/step-components';

const steps = ['CHOOSE_ANALYSIS', ...SHARED_SOURCING_STEPS] as const;
export type SourcingInternalStep = (typeof steps)[number];

type SourcingInternalStepComponent = {
  [K in SourcingInternalStep]: React.ComponentType;
};

export const sourcingInternalStepComponents: SourcingInternalStepComponent = {
  CHOOSE_ANALYSIS: SourcingInternalChooseAnalysisStep,
  SELECTED_CANDIDATES: SourcingInternalSelectedCandidatesStep,
  CHOOSE_CHANNEL: SourcingInternalChooseChannelStep,
  JOB_INFORMATION: SourcingInternalJobInformationStep,
  SETUP_APPLICATION: SourcingInternalSetupApplicationStep,
  CUSTOMIZE_MESSAGE: SourcingInternalCustomizeMessageStep,
  REVIEW_INVITATIONS: SourcingInternalReviewInvitationsStep,
  SUCCESS: SourcingInternalSuccessStep
};
